export function LoginPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-900">
      <div className="card w-full max-w-md text-center">
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
          BRIDGE AI
        </h1>
        <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
          SEND intelligence platform
        </p>
        <p className="mt-8 text-xs text-slate-400">Login form — Phase B</p>
      </div>
    </div>
  );
}
